import { Box } from "@chakra-ui/react";
import { PositionedEvent, CalendarEvent, SlotStyle } from "../../types";
import BackgroundGrid from "./BackgroundGrid";
import EventsLayer from "./EventsLayer";

interface CalendarColumnProps {
  columnIndex: number;
  date: Date;
  events: PositionedEvent[];
  hours: number[];
  slotHeight: number;
  show15Minutes: boolean;
  timezone: string;
  dragged: PositionedEvent | null;
  resizing: PositionedEvent | null;
  onMouseDown: (e: React.MouseEvent, event: PositionedEvent) => void;
  onResizeStart: (e: React.MouseEvent, event: PositionedEvent) => void;
  onEventClick?: (event: CalendarEvent) => void;
  getSlotStyle?: (time: Date, columnIndex: number) => SlotStyle | undefined;
  children?: React.ReactNode;
}

export default function CalendarColumn({
  columnIndex,
  date,
  events,
  hours,
  slotHeight,
  show15Minutes,
  timezone,
  dragged,
  resizing,
  onMouseDown,
  onResizeStart,
  onEventClick,
  getSlotStyle,
  children,
}: CalendarColumnProps) {
  return (
    <Box position="relative" borderLeftWidth="1px" borderLeftColor="gray.200">
      <BackgroundGrid
        hours={hours}
        slotHeight={slotHeight}
        show15Minutes={show15Minutes}
        columnIndex={columnIndex}
        getSlotStyle={getSlotStyle}
        date={date}
        timezone={timezone}
      />
      <EventsLayer
        events={events}
        timezone={timezone}
        dragged={dragged}
        resizing={resizing}
        onMouseDown={onMouseDown}
        onResizeStart={onResizeStart}
        onEventClick={onEventClick}
      />
      {children}
    </Box>
  );
}
